module.exports = __webpack_public_path__ + "img/promo.e71bfc2.jpg";